import { WorkoutListPage } from '../../component/workout-list-page/workout-list-page'
import { DEFAULT_WORKOUT_SORT } from '../../context/filter-context'
import { usePaginatedWorkouts } from '../../hook/use-paginated-workouts'
import { CORE_CHARGE_STYLE_ID } from '../../service/core-service'
import React from 'react'

export const CoreChargeWorkoutsScreen = (): React.ReactElement => {
  const { workouts, totalPages, page, setPage, isLoading } = usePaginatedWorkouts(
    { styles: [CORE_CHARGE_STYLE_ID] },
    DEFAULT_WORKOUT_SORT,
  )

  return (
    <WorkoutListPage
      title="Core Charge"
      workouts={workouts}
      isLoading={isLoading}
      page={page}
      totalPages={totalPages}
      onPageChange={setPage}
    />
  )
}
